/* eslint-disable camelcase */
import { createContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import appLocalStorage from '@src/lib/storage/localStorage';

import * as api from '@src/common/api';

interface IUserProviderProps {
  children: any;
  initValue?: IUserContext;
}

export interface IUserContext {
  authToken: any;
  user: any;
  isVerification: boolean;
  loginUser: (userData: any) => void;
  logoutUser: () => void;
  updateVerification: (_value: boolean) => void;
  initUser?: (_user: any) => void;
}

const STORAGE_USER_KEY = 'lotteopen.auth';
export const UserContext = createContext<IUserContext>({
  authToken: {},
  user: null,
  isVerification: false,
  loginUser: (_userData) => {
    // null
  },
  logoutUser: () => {
    // null
  },
  updateVerification: (_value) => {
    // null
  },
  initUser: (_user) => {
    // null
  },
});

const getMyPageInfoBlockRouter = ['/_o/google', '/_o/kakao', '/_o/naver'];
export default function UserProvider({
  children,
  initValue,
}: IUserProviderProps) {
  const [authToken, setAuthToken] = useState(null);
  const [user, setUser] = useState<any>(null);
  const [isVerification, setVerifications] = useState(false);
  const routerHistory = useHistory();

  const initUser = (user: any) => {
    setUser(user);
  };

  const loginUser = (userData: any) => {
    setAuthToken(userData);
    appLocalStorage.set({ [STORAGE_USER_KEY]: userData });
  };

  const removeAllUserInfo = () => {
    setAuthToken(null);
    appLocalStorage.clean([STORAGE_USER_KEY]);
  };

  const logoutUser = () => {
    const { location } = window;
    removeAllUserInfo();
    location.href = '/';
  };

  const updateVerification = (result: any) => {
    setVerifications(result);
  };

  useEffect(() => {
    const authStorageData = appLocalStorage.get(STORAGE_USER_KEY);
    setAuthToken(authStorageData || null);
  }, []);

  // 토큰이 변경될 경우 유저데이터 새로 받아옴
  useEffect(() => {
    if (authToken) {
      if (
        getMyPageInfoBlockRouter.indexOf(routerHistory.location.pathname) === -1
      ) {
        api
          .getMyPageInfo()
          .then((res: any) => {
            if (res?.data?.error !== 'Unauthorized' || res.status !== 401) {
              setUser(res?.data?.data);
            } else {
              removeAllUserInfo();
            }
          })
          .catch((err) => console.error(err));
      }
    } else {
      setUser(null);
    }
  }, [authToken]);

  // 유저정보가 변경될 경우 인증 체크
  useEffect(() => {
    if (user) {
      api
        .getMyVerifications()
        .then((res: any) => {
          if (res?.data?.data) {
            setVerifications(true);
          } else {
            setVerifications(false);
          }
        })
        .catch((_err) => {
          setVerifications(false);
        });
    } else {
      setVerifications(false);
    }
  }, [user]);

  return (
    <UserContext.Provider
      value={
        initValue || {
          user,
          authToken,
          loginUser,
          logoutUser,
          isVerification,
          updateVerification,
          initUser,
        }
      }
    >
      {children}
    </UserContext.Provider>
  );
}
